/**
 * In this file, we create a React component
 * which incorporates components providedby material-ui.
 */

import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {deepOrange500} from 'material-ui/styles/colors';
import TextField from 'material-ui/TextField';
import AppBar from 'material-ui/AppBar';
import Snackbar from 'material-ui/Snackbar';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import reqwest from 'reqwest';


const styles = {
  container: {
    textAlign: 'center',
    paddingTop: 200,
  },
};

var apiUrl = "/api/public/messages";

const muiTheme = getMuiTheme({
  palette: {
    accent1Color: deepOrange500,
  },
});


var CommentBox = React.createClass({

  handleSubmit: function(event) {
    event.preventDefault();
    var text = this.state.text.trim();

    if(text && text.length && text.length < 140){
      reqwest({
          url: apiUrl
        , method: 'post'
        , crossOrigin: true
        , data: { Body: text, key: '4399AEBE-17D9-44AF-B257-A5C50E272504' }
        , success: function (resp) {
          this.setState({
              open: true,
              text: ''
            });
          }.bind(this)
          ,error: function(err){
            console.log(err);
          }
      });
    }
  },

  getInitialState: function() {
    return {
      open: false,
      message: 'Message successfully sent',
      numChar: 140,
      text: ''
    };
  },

  handleRequestClose: function() {
    this.setState({
      open: false,
    });
  },

  handleChange: function(event){
      this.setState({text: event.target.value.length < 140 ? event.target.value : this.state.text, numChar: 140 - event.target.value.length});
  },

  handleKeyPress: function(event){
    if (event.key === 'Enter') {
      this.handleSubmit(event);
    }
  },

  render: function() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
      <div className="app">
      <img className="logo" src="/img/logo.png" />
      <div className="form">
      <TextField hintText="Share right here..." value={this.state.text} ref="text" id="text" textareaStyle={{color: '#fff', fontFamily: 'sofia-pro', fontWeight: '600', fontSize: '22px'}} hintStyle={{color: 'rgba(255,255,255,0.7)', fontFamily: 'sofia-pro', fontWeight: '600', fontSize: '22px'}} underlineFocusStyle={{borderColor:'#fff'}} multiLine={true} rowsMax={5} className="textfield" onChange={this.handleChange} onKeyDown={this.handleKeyPress}/>
      <RaisedButton label="Share" onMouseUp={this.handleSubmit} className="button" labelStyle={{color: '#EF4237', fontFamily: 'sofia-pro', fontWeight: '600', fontSize: '22px'}}/>
      <h3>{this.state.numChar} characters left</h3>
      </div>
      <Snackbar
          open={this.state.open}
          message={this.state.message}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose}
        />
      </div>
      </MuiThemeProvider>
    );
  }
});

export default CommentBox;



/** WEBPACK FOOTER **
 ** ./src/app/Main.js
 **/